<template>

    <div v-if="success">
        <div class="py-12">
            <div>
                <i class="fas fa-check-circle text-6xl text-success"></i>
            </div>
            <div class="text-xl mt-5">
                Success!
            </div>
            <div class="style-body mt-5">
                <p class="mb-2">
                    Password has been updated successfully!
                </p>
                <div class="mt-8">
                    <router-link
                            :to="{ name: 'signIn' }"
                            class="text-red hover:text-red-hover font-light underline cursor-pointer">
                        Go to Login
                    </router-link>
                </div>
            </div>
        </div>
    </div>

    <form v-else  class="form" @submit.prevent="formSubmit" ref='form' >
        <div :class="{hidden: !loading}">
            <loading></loading>
        </div>
        <div :class="{hidden: loading}">
            <div v-if="user" class="style-emph mb-4">Hi {{ user.first_name }}. Please update your password here. </div>

            <div v-if="urlError" class="style-emph mb-4 text-red">
                <div class="mb-5">
                    {{ urlError }}
                </div>

                <router-link
                        :to="{ name: 'signIn' }"
                        class="text-red hover:text-red-hover font-light underline cursor-pointer">
                    Go to Login
                </router-link>
            </div>

            <div v-else>
                <div class="mb-5">
                    <div class="input-container input-container--floating relative h-12 "
                         :class="{empty: !formData.password, error: submittedOnce && errors.password}">
                        <input
                                id="password-reset"
                                type="password"
                                v-model="formData.password"
                                class="h-full w-full border-gray-300 px-2 transition-all border-blue-gray rounded text-blue"
                                autocomplete="on"
                        />
                        <label for="password-reset" class="absolute left-2 transition-all px-1 text-blue-gray">
                            New Password
                        </label>
                    </div>

                    <div class="text-sm mt-2" v-if="formData.password.length">
                        <ul>
                            <li :class="{'text-red': passwordLengthError}">
                                - Password need to have minimum eight characters
                            </li>
                            <li :class="{'text-red': passwordOneLetterError}">
                                - Password need to have at least one letter
                            </li>
                            <li :class="{'text-red': passwordOneNumberError}">
                                - Password need to have at least one number
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="mb-5">
                    <div class="input-container input-container--floating relative h-12 "
                         :class="{empty: !formData.confirmPassword, error: submittedOnce && errors.confirmPassword}">
                        <input
                                id="confirm-password"
                                type="password"
                                v-model="formData.confirmPassword"
                                class="h-full w-full border-gray-300 px-2 transition-all border-blue-gray rounded text-blue"
                                autocomplete="on"
                        />
                        <label for="confirm-password" class="absolute left-2 transition-all px-1 text-blue-gray">
                            Confirm Password
                        </label>
                    </div>

                    <div v-if="submittedOnce && errors.confirmPassword " class="text-red text-sm mt-2 leading-none">
                        {{ errors.confirmPassword }}
                    </div>
                </div>


                <div v-if="errors.message" class="bg-red text-white mb-5 px-3 py-2 rounded ">
                    {{ errors.message }}
                </div>

                <div class="mt-10 flex flex-col md:flex-row items-center ">
                    <button type="submit" class="btn w-full md:w-auto">Set New Password</button>
                    <router-link
                            :to="{ name: 'signIn' }"
                            class="mt-3 md:mt-0 md:ml-8 text-red hover:text-red-hover font-light underline cursor-pointer">
                        Cancel Form
                    </router-link>
                </div>
            </div>
        </div>
    </form>
</template>


<script charset="utf-8">

    import { values, join, get } from 'lodash';
    import Loading from '../includes/Loading.vue';
    import Vuex from 'vuex';

    export default {
        data() {
            return {
                loading: true,
                submittedOnce: false,
                success: false,
                urlError: "",
                user: null,

                formData: {
                    password: '',
                    confirmPassword: ''
                },

                errors: {
                    password: 'Password is required',
                    confirmPassword: 'Confirm password is required',
                }
            }
        },
        components: {
            Loading
        },

        emits: ["submit-success"],
        watch: {
            formData: {
                handler(newVal){
                    const regex1= /^.*[0-9].*$/;
                    const regex2= /^.*[a-zA-Z].*$/;

                    this.errors.message = '';

                    if(!regex1.test(newVal.password)){
                        this.errors.password = 'Password need to have at least one number';
                    }else if (!regex2.test(newVal.password)){
                        this.errors.password = 'Password need to have at least one letter';
                    }else if (newVal.password.length < 8){
                        this.errors.password = 'Password need to have minimum eight characters';
                    }else{
                        this.errors.password = '';
                    }

                    this.errors.confirmPassword  = (newVal.password == newVal.confirmPassword)  ? '' : 'Confirm password is not matched';
                },
                deep: true
            }
        },

        computed: {
            passwordLengthError: function () {
                return this.formData.password.length < 8;
            },
            passwordOneNumberError: function () {
                const regex= /^.*[0-9].*$/;
                return !regex.test(this.formData.password);
            },
            passwordOneLetterError: function () {
                const regex= /^.*[a-zA-Z].*$/;
                return !regex.test(this.formData.password);
            },
        },

        created() {
            let secretToken = this.$router.currentRoute.value.params.secretToken;
            if(secretToken){
               this.getUserByResetPasswordToken(secretToken).then(res => {
                  this.loading = false;
                  this.user = res;
                  if(!this.user){
                      this.urlError = 'The reset password link is expired or incorrect.';
                  }
               });
            }else{
               this.urlError = 'The reset password link is expired or incorrect.';
            }
        },

        methods: {
            ...Vuex.mapActions('profile', {
                resetPassword: 'resetPassword',
                getUserByResetPasswordToken: 'getUserByResetPasswordToken'
            }),
            formSubmit() {
                this.submittedOnce = true;
                this.errors.message = '';

                if (join(values(this.errors), '')) {
                    return;
                }

                let data = {
                    password: this.formData.password,
                    token: this.$router.currentRoute.value.params.secretToken
                };

                this.resetPassword(data)
                    .then(() => {
                        this.loading = false;
                        this.successMessage = 'User password has been updated';
                        this.$emit('submit-success');
                    })
                    .catch(() => {
                        this.loading = false;
                        this.errors = {
                            message: 'Invalid data'
                        }
                    })

                this.success = true;
                this.$emit('submit-success');

            }
        },
    }
</script>
